import { get, post,postUrlEncoded } from "./http";
const apiSDK = 'https://api.eternaldragoon.com/v1';
const apiOffical = 'https://game.eternaldragoon.com/api';
// const apiOffical = 'https://game.eternaldragoon.com/api';
// const apiOffical = 'https://sandbox.xiaomaglobe.com/api';
// const apiOffical = 'http://192.168.5.227:1234';


export const api = {
    // 账号登陆
    login(data) {
        return post(apiSDK + '/member/signin', data)
    },
    // 账号注册
    register(data) {
        return post(apiSDK + '/member/signup', data)
    },
    // token验证登录状态
    tokenLogin(data) {
        return post(apiSDK + '/member/verify', data)
    },
    // 谷歌登陆
    googleLogin(data) {
        return post(apiSDK + '/member/google', data)
    },
    // facebook登陆
    facebookLogin(data) {
        return post(apiSDK + '/member/facebook', data)
    },
    // 苹果登陆
    appleLogin(data) {
        return post(apiSDK + '/member/apple', data)
    },
    //服务器列表
    gameList(data) {
        return get(apiOffical + '/game/webapp', data)
    },
    //服务器列表
    serverList(data) {
        return post(apiOffical + '/game/servers', data)
    },
    //角色列表
    roleList(data) {
        return post(apiOffical + '/game/roles', data)
    },
    // 确认订单状态
    orderStatus(data) {
        return post(apiOffical + '/order/query', data)
    },
    //元宝商品列表
    productsList(data) {
        return post(apiOffical + '/game/products', data)
    },
    pay(d) {
        return post(apiOffical + '/game/pay', d)
    },
    gash(d) {
        return postUrlEncoded('https://stage-api.eg.gashplus.com/CP_Module/order.aspx', d)
    }

}